export default (state = {}, { payload, type }) => {
    switch (type) {
        case 'GET_VERSION':
            return {
                ...state,
                [payload.env]: payload.version,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/version.js